import { Ref, forwardRef } from "react"
import * as yup from "yup"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../shared/components/forms/SchemaFormik"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { CreateUpdateSalesAccountFormContent } from "./CreateUpdateSalesAccountFormContent"
import { SalesAccountBase } from "../salesAccountsTypes"

type CreateUpdateSalesAccountFormProps = Readonly<{
    initialValues: SalesAccountBase
    onSubmit: (formData: SalesAccountBase) => void
}>
type FormikRef = Ref<FormikProps<SalesAccountBase>>

export const CreateUpdateSalesAccountForm = forwardRef(
    ({ initialValues, onSubmit }: CreateUpdateSalesAccountFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
            number: yup.string().required(l10n.getString("required-field")),
        })

        function handleSubmit(values: SalesAccountBase) {
            onSubmit(values)
        }

        return (
            <>
                <Formik<SalesAccountBase>
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={ref}
                >
                    <Form>
                        <CreateUpdateSalesAccountFormContent />
                    </Form>
                </Formik>
            </>
        )
    },
)
